<template>
  <b-card no-body class="overflow-hidden m-0 p-0">
    <b-row no-gutters>
      <b-col class="hw-fixed">
        <job-media-wrapper :job="entity" v-if="entity.itemType === 'job'"></job-media-wrapper>
        <entity-media-wrapper :entity="entity" v-else></entity-media-wrapper>
      </b-col>
      <b-col align-self="center" class="col-width">
        <b-card-body class="pb-2 pt-2 text-truncate text-center align-items-center" >

          <router-link :to="{ name: 'File Details', params: { size: entity.size, checksum: entity.checksum }}"><h5 class="card-title m-0 ">{{name}}</h5></router-link>
          <div><small>{{ entity.size | bytes }}</small></div>
          <div><small class="text-muted">{{ entity.dateLastUpdated | moment("from") }}</small></div>
        </b-card-body>
      </b-col>
      <manifest-cart-add-remove-item :entity="entity" v-show="!hideCart"></manifest-cart-add-remove-item>
    </b-row>
  </b-card>
</template>

<script>

import EntityMediaWrapper from '#/ui/Components/Entities/EntityMediaWrapper.vue';
import ManifestCartAddRemoveItem from '#/ui/Components/Manifest/ManifestCartAddRemoveItem.vue';
import JobMediaWrapper from '#/ui/Components/Jobs/JobMediaWrapper.vue';

export default {
  components: {
    EntityMediaWrapper,
    ManifestCartAddRemoveItem,
    JobMediaWrapper,
  },
  props: {
    entity: {
      type: Object,
      required: true,
    },
    hideCart: {
      type: Boolean,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    name() {
      // properly make sure this stays as one row. and doesn't trigger overflow into a second row
      let name = this.entity.name ? this.entity.name : '(No Name)';
      if (name.length > 15) {
        name = `${name.substring(0, 15)}...`;
      }
      return name;
    },
  },
  methods: {
    openFile() {
      console.log('open entity clicked', this.entity);
      const path = `/files/${this.entity.size}/${this.entity.checksum}`;
      this.$router.push(path);
    },
  },
};

</script>

<style scoped lang="scss">
.hw-fixed {
  width: 273px;
}
</style>
